/**
 * Parse a price string that may use either "." or "," as the decimal separator.
 * e.g. "12.5" and "12,5" both return 12.5
 */
export function parsePrice(value: string): number {
    return parseFloat(value.replace(',', '.'));
}
